import { createContext, useState} from "react"

const TeamContext = createContext();

const PASSING_URL = process.env.REACT_APP_NFL_PASSING_URL
const RUSHING_URL = process.env.REACT_APP_NFL_RUSHINING_URL
const RECEIVING_URL = process.env.REACT_APP_NFL_RECEIVING_URL
const WIN_URL = process.env.REACT_APP_NFL_WIN_URL
const KEY_URL = process.env.REACT_APP_NFL_KEY
const HOST_URL = process.env.REACT_APP_NFL_HOST

// Provides all functions required to fetch data and manage state
export const TeamStatsProvider = ({children}) => {
    
    const [receivingStats, setReceivingStats] = useState([])
    const [rushingStats, setRushingStats] = useState([])
    const [passingStats, setPassingStats] = useState([])
    const [winStats, setWinStats] = useState([])
    const [conference, setConference] = useState('select-conference')
    const [division, setDivision] = useState('select-division')
    const [team, setTeam] = useState('select-team')
    const [year, setYear] = useState('select-year')
    const [loading, setLoading] = useState(false)

    const handleConferenceChange = (e) => {
        setConference(e.target.value)
    }

    const handleDivisionChange = (e) => {
        setDivision(e.target.value)
    }

    const handleTeamChange = (e) => {
        setTeam(e.target.value)
    }

    const handleYearChange = (e) => {
        setYear(e.target.value)
    }

    function getStats() {
        getPassingStats();
        getRushingStats();
        getReceivingStats();
        getWinStats();
        setLoading(true)
    }

    const getPassingStats = async () => {
        const options = {
            method: 'GET',
            headers: {
              'X-RapidAPI-Key': '15be8b3d2emshf87344a81b6dd5bp14be87jsncfc80aa92b91',
              'X-RapidAPI-Host': 'nfl-team-stats.p.rapidapi.com'
            }
          };
        
        //   Init specific team
        const thisTeam = team
        
        //   Passing Stats
        const passingResponse = await fetch(`https://nfl-team-stats.p.rapidapi.com/v1/nfl-stats/teams/passing-stats/offense/${year}`, options)
        const passingResponseData = await passingResponse.json();
        const pass = passingResponseData._embedded.teamPassingStatsList.forEach(function(team) {
            if(thisTeam === team.name) {
                setPassingStats(team)
                setLoading(false)
            }
        })
        return passingResponseData
    }

    const getRushingStats = async () => {
        const options = {
            method: 'GET',
            headers: {
              'X-RapidAPI-Key': '15be8b3d2emshf87344a81b6dd5bp14be87jsncfc80aa92b91',
              'X-RapidAPI-Host': 'nfl-team-stats.p.rapidapi.com'
            }
          };
        
        //   Init specific team
        const thisTeam = team
        
        //   Rushing Stats
        const rushingResponse = await fetch(`https://nfl-team-stats.p.rapidapi.com/v1/nfl-stats/teams/rushing-stats/offense/${year}`, options)
        const rushingResponseData = await rushingResponse.json();
        const rush = rushingResponseData._embedded.teamRushingStatsList.forEach(function(team) {
            if(thisTeam === team.name) {
                setRushingStats(team)
                setLoading(false)
            }
        })
        return rushingResponseData
    }

    const getReceivingStats = async () => {
        const options = {
            method: 'GET',
            headers: {
              'X-RapidAPI-Key': '15be8b3d2emshf87344a81b6dd5bp14be87jsncfc80aa92b91',
              'X-RapidAPI-Host': 'nfl-team-stats.p.rapidapi.com'
            }
          };
        
        //   Init specific team
        const thisTeam = team
        
        //   Receiving Stats
        const receivingResponse = await fetch(`https://nfl-team-stats.p.rapidapi.com/v1/nfl-stats/teams/receiving-stats/offense/${year}`, options)
        const receivingResponseData = await receivingResponse.json();
        const receive = receivingResponseData._embedded.teamReceivingStatsList.forEach(function(team) {
            if(thisTeam === team.name) {
                setReceivingStats(team)
                setLoading(false)
            }
        })
        return receivingResponseData
    }

    const getWinStats = async () => {
        const options = {
            method: 'GET',
            headers: {
              'X-RapidAPI-Key': '15be8b3d2emshf87344a81b6dd5bp14be87jsncfc80aa92b91',
              'X-RapidAPI-Host': 'nfl-team-stats.p.rapidapi.com'
            }
          };
        
        //   Init specific team
        const thisTeam = team
        
        //   Win Stats
        const winResponse = await fetch(`https://nfl-team-stats.p.rapidapi.com/v1/nfl-stats/teams/win-stats/${year}`, options)
        const winResponseData = await winResponse.json();
        const win = winResponseData._embedded.teamWinStatsList.forEach(function(team) {
            if(team.name.includes(thisTeam)) {
                setWinStats(team)
                setLoading(false)
            }
        })
        return winResponseData
    }
    


    return (
        <TeamContext.Provider value={{
            receivingStats,
            rushingStats,
            passingStats,
            winStats,
            conference,
            division,
            team,
            year,
            loading,
            getStats,
            handleConferenceChange,
            handleDivisionChange,
            handleTeamChange,
            handleYearChange,
        }}>
            {children}
        </TeamContext.Provider>
    )
}

export default TeamContext
